var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.deliverable && !_vm.disabled
    ? _c(
        "div",
        { staticClass: "social-deliverable-campaigns" },
        [
          !_vm.disabled
            ? [
                !_vm.addCampaignFlag
                  ? _c("div", { staticClass: "pb-0 exclude-outside-click" }, [
                      _c("div", { staticClass: "department-label" }, [
                        _vm._v("Campaign")
                      ]),
                      _vm._v(" "),
                      _vm.deliverable.social_campaigns.length
                        ? _c(
                            "div",
                            {
                              key:
                                "deliverable-modal-department-" +
                                _vm.deliverable.social_campaigns[0],
                              staticClass:
                                "department-title exclude-outside-click",
                              class: _vm.canEditSocialCampaign(
                                _vm.selectedCampaign
                              )
                                ? ""
                                : "pointer-default",
                              on: { click: _vm.clickTitle }
                            },
                            [
                              _vm._v(
                                "\n        " +
                                  _vm._s(_vm.campaignTitle) +
                                  "\n      "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.deliverable.social_campaigns.length
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "department-title exclude-outside-click",
                              on: {
                                click: function($event) {
                                  return _vm.showAddSocialCampaign()
                                }
                              }
                            },
                            [_vm._v("None")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.canEditSocialCampaign(_vm.selectedCampaign)
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "plus-button plus-button--small exclude-outside-click",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.showAddSocialCampaign()
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "exclude-outside-click",
                                attrs: {
                                  src: require("@/csmworkflow/img/pencil.svg")
                                }
                              })
                            ]
                          )
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.addCampaignFlag
                  ? _c("div", { staticClass: "department-label" }, [
                      _vm._v("Assign to a different campaign")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.addCampaignFlag
                  ? _c("multiselect", {
                      directives: [
                        {
                          name: "click-outside",
                          rawName: "v-click-outside",
                          value: _vm.outside,
                          expression: "outside"
                        }
                      ],
                      ref: "socialCampaigns",
                      attrs: {
                        "close-on-select": true,
                        options: _vm.campaignsOption,
                        "show-labels": false,
                        multiple: false,
                        taggable: true,
                        label: "name",
                        "track-by": "id",
                        id: _vm.deliverable.deliverableId
                      },
                      on: {
                        tag: _vm.createCampaign,
                        input: function($event) {
                          return _vm.socialCampaignSelected()
                        },
                        close: function($event) {
                          _vm.addCampaignFlag = false
                        }
                      },
                      model: {
                        value: _vm.selectedCampaign,
                        callback: function($$v) {
                          _vm.selectedCampaign = $$v
                        },
                        expression: "selectedCampaign"
                      }
                    })
                  : _vm._e()
              ]
            : [
                _c(
                  "div",
                  { staticClass: "pb-0 titles exclude-outside-click" },
                  [
                    _vm.deliverable.social_campaigns.length
                      ? _c(
                          "div",
                          {
                            key:
                              "deliverable-modal-department-" +
                              _vm.deliverable.social_campaigns[0],
                            staticClass:
                              "department-title exclude-outside-click"
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.deliverable.social_campaigns[0]) +
                                "\n      "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.deliverable.social_campaigns.length
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "department-title exclude-outside-click"
                          },
                          [_vm._v("No Campaign")]
                        )
                      : _vm._e()
                  ]
                )
              ]
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }